/*=========================================================================================
  File Name: moduleEmployeeMutations.js
  Description: Employee Module Mutations
==========================================================================================*/

export default {
	SET_EMPLOYEES_SEARCH_QUERY(state, query) {
		state.employeesSearchQuery = query;
	},
	UPDATE_EMPLOYEES_FILTER(state, filter) {
		state.employeesFilter = filter;
	},

	// API
	SET_EMPLOYEES(state, employees) {
		state.employees = employees;
	},

	ADD_EMPLOYEE(state, employee) {
		state.employees.unshift(employee);
	},

	UPDATE_EMPLOYEE(state, employee) {
		const employeeIndex = state.employees.findIndex(t => t.id === employee.id);
		Object.assign(state.employees[employeeIndex], employee);
	},

	DELETE_EMPLOYEE(state, employeeId) {
		const employeeIndex = state.employees.findIndex(t => t.id == employeeId);
		state.employees.splice(employeeIndex, 1);
	},
	SET_TOTAL_EMPLOYEES(state, total) {
		state.total = total;
	},
};
